/**
 * Obligo Section Component
 * Displays obligo exceptions and released orders history with tab navigation
 */

import {
  Box,
  Paper,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
  Divider,
  Fade,
} from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import ObligoExceptionDetails from "../../../components/Obligo/obligoOrders";
import { ReleasedOrdersHistory } from "../../../components/ApproveLines/ReleasedOrdersHistory";
import { OBLIGO_TABS } from "../constants";

const ObligoSection = ({
  tabValue,
  onTabChange,
  obligoDetails,
  ordersLog,
  isLoading,
}) => {
  return (
    <Fade in timeout={1200}>
      <Box mt={6}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            mb: 3,
          }}
        >
          <WarningIcon sx={{ color: "#FF9800", fontSize: 28 }} />
          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              color: "rgba(0,0,0,0.87)",
            }}
          >
            הזמנות בחריגת אובליגו
          </Typography>
        </Box>

        <Paper
          elevation={0}
          sx={{
            borderRadius: 3,
            overflow: "hidden",
            border: "1px solid rgba(0,0,0,0.08)",
          }}
        >
          <Box sx={{ p: 2, bgcolor: "#FFF9E0" }}>
            <ToggleButtonGroup
              value={tabValue}
              exclusive
              onChange={onTabChange}
              aria-label="הזמנות בחריגת אובליגו"
              sx={{
                "& .MuiToggleButton-root": {
                  border: "none",
                  borderRadius: "8px",
                  mx: 0.5,
                  px: 3,
                  py: 1,
                  "&.Mui-selected": {
                    bgcolor: "#FF9800",
                    color: "white",
                    "&:hover": {
                      bgcolor: "#FFA726",
                    },
                  },
                  "&:hover": {
                    bgcolor: "#FFE0B2",
                  },
                },
              }}
            >
              <ToggleButton value={OBLIGO_TABS.EXCEPTIONS}>
                הזמנות בחריגה
              </ToggleButton>
              <ToggleButton value={OBLIGO_TABS.HISTORY}>
                היסטורית הזמנות משוחררות
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>

          <Divider />

          <Box sx={{ p: 2, bgcolor: "white" }}>
            {tabValue === OBLIGO_TABS.EXCEPTIONS ? (
              <ObligoExceptionsTab
                obligoDetails={obligoDetails}
                isLoading={isLoading}
              />
            ) : (
              <OrdersHistoryTab ordersLog={ordersLog} />
            )}
          </Box>
        </Paper>
      </Box>
    </Fade>
  );
};

/**
 * Obligo Exceptions Tab Content
 */
const ObligoExceptionsTab = ({ obligoDetails, isLoading }) => {
  return (
    <Box className="App">
      <Box sx={{ display: { xs: "none", sm: "block" } }}>
        <ObligoExceptionDetails details={obligoDetails} isLoading={isLoading} />
      </Box>
      <Box sx={{ display: { xs: "block", sm: "none" } }}>
        <Typography variant="body2" color="text.secondary" align="center" py={4}>
          אנא עבור למסך גדול יותר לצפייה בפרטי ההזמנות
        </Typography>
      </Box>
    </Box>
  );
};

/**
 * Orders History Tab Content
 */
const OrdersHistoryTab = ({ ordersLog }) => {
  return (
    <Box sx={{ minHeight: "300px", position: "relative" }}>
      <Box sx={{ display: { xs: "none", sm: "block" } }}>
        {ordersLog ? (
          <ReleasedOrdersHistory releasedOrders={ordersLog} />
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "300px",
            }}
          >
            <Typography variant="body1" color="text.secondary">
              טוען היסטוריית הזמנות...
            </Typography>
          </Box>
        )}
      </Box>
      <Box sx={{ display: { xs: "block", sm: "none" } }}>
        <Typography variant="body2" color="text.secondary" align="center" py={4}>
          אנא עבור למסך גדול יותר לצפייה בהיסטוריית ההזמנות
        </Typography>
      </Box>
    </Box>
  );
};

export default ObligoSection;
